// extracted by mini-css-extract-plugin
module.exports = {"alert":"Alert_alert__13I1A","success":"Alert_success__1Ir96","danger":"Alert_danger__1Oz9H"};